module.exports = __webpack_public_path__ + "static/media/newsletter-pic.868928eb.svg";